var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"build-detail-row"},[(_vm.hasTitle)?_c('span',{staticClass:"build-light-text"},[_vm._v("\n    "+_vm._s(_vm.title)+":\n  ")]):_vm._e(),_vm._v("\n  "+_vm._s(_vm.value)+"\n")])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a2b85ae","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./jobs/components/sidebar_detail_row.vue
// module id = null
// module chunks = 